import { Autocomplete, TextField } from '@mui/material'
import { ItemsQuery } from '@kistill/client/data-access'

interface ItemChipProps {
  data: ItemsQuery | undefined
}
// TODO: Breyta  úr ItemQuery í ItemTitleQuery svo þetta virki rétt
export function ItemTitleChip({ data }: ItemChipProps) {
  const options = data?.items?.map((option) => {
    const firstLetter = option.json?.titill[0].toUpperCase()
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    }
  })

  // TODO: Setja upp að þessi gildi sorteri fielda í search
  return (
    <Autocomplete
      multiple
      size='small'
      id='titill'
      renderInput={(params) => <TextField {...params} label='Titill' />}
      groupBy={(option) => option.firstLetter}
      getOptionLabel={(option) => option.titill}
      isOptionEqualToValue={(items, options) =>
        items?.titill === options.titill
      }
      options={[
        ...(options
          ?.map((x) => ({
            titill: x.json.titill,
            firstLetter: x.firstLetter,
          }))
          .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter)) ?? []),
      ]}
    />
  )
}
export default ItemTitleChip
